import React from 'react';
import { BackButton, Box, Center, Text, ZStack } from '~/commonComponents';

export const HeaderSection: React.FC = () => {
  return (
    <>
      <Box position="relative" marginBottom={32} marginTop={40}>
        <Center>
          <ZStack left={8}>
            <BackButton />
          </ZStack>

          <Text fontSize={32} bold textAlign="center">
            How It Works
          </Text>
        </Center>
      </Box>

      <Center marginBottom={32} maxWidth={640}>
        <Text fontSize={16} textAlign="center" color={'neutral_500'}>
          GoTu connects you with licensed, verified dental professionals, on your schedule and at
          your rate. You post the shift, approve the day, and we handle the rest. It&apos;s that
          simple.
        </Text>
      </Center>
    </>
  );
};
